import { GlobalAxios } from "./../axios/axios-config";
import {
  INewUBusRelationshipGroup,
  IUBusRelationshipGroup,
} from "../models/u-bus-relationship-group";
import { ISelectType } from "@4uhub/lib4uhub";

const U_BUS_RELATIONSHIP_GROUP_ROUTE =
  process.env.REACT_APP_MAIN + "/api/v1/4uBusRelationshipGroup/";

export const createUBusRelationshipGroup = (
  item: INewUBusRelationshipGroup,
) => {
  return GlobalAxios.post(U_BUS_RELATIONSHIP_GROUP_ROUTE, item);
};

export const getUBusRelationshipGroupById = (id: string) => {
  return GlobalAxios.get<IUBusRelationshipGroup>(
    U_BUS_RELATIONSHIP_GROUP_ROUTE + id,
  );
};

export const updateUBusRelationshipGroupById = ({
  item,
  id,
}: {
  item: INewUBusRelationshipGroup;
  id: string;
}) => {
  return GlobalAxios.put(U_BUS_RELATIONSHIP_GROUP_ROUTE + id, item);
};
export const uBusRelationshipGroupList = (params?: any) => {
  return GlobalAxios.get<ISelectType[]>(
    U_BUS_RELATIONSHIP_GROUP_ROUTE + "list",
    {
      params,
    },
  );
};
